import { render } from "./PodcastsView.vue?vue&type=template&id=1f320ca1&scoped=true"
import script from "./PodcastsView.vue?vue&type=script&lang=js"
export * from "./PodcastsView.vue?vue&type=script&lang=js"

import "./PodcastsView.vue?vue&type=style&index=0&id=1f320ca1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f320ca1"]])

export default __exports__